var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.paymentView
    ? _c(
        "div",
        [
          _c(
            "v-app",
            [
              _vm.paymentView
                ? _c("div", { staticClass: "dashboard-main-content" }, [
                    _c("div", { staticClass: "container-fluid" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-lg-12" }, [
                          _c("form", { attrs: { id: "agencyDetailFrom" } }, [
                            _c("div", { staticClass: "form-box" }, [
                              _c("div", { staticClass: "form-content pb-2" }),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-content pb-2" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "row justify-content-between",
                                  },
                                  [
                                    _c("div", { staticClass: "col-lg-6" }, [
                                      _c(
                                        "div",
                                        { staticClass: "card-item p-3" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "contact-form-action",
                                            },
                                            [
                                              _c(
                                                "h3",
                                                { staticClass: "title mb-3" },
                                                [_vm._v("Acente Cari Tablo")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "theme-btn",
                                        staticStyle: {
                                          height: "50px",
                                          "margin-right": "10px !important",
                                        },
                                        attrs: { type: "button" },
                                        on: { click: _vm.addPayment },
                                      },
                                      [_vm._v("Ödeme Ekle")]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-lg-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "card-item p-3" },
                                    [
                                      _c("agency-payment-view-list", {
                                        attrs: {
                                          "payment-view": _vm.paymentView,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                              ]),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("agency-add-payment-popup", {
                attrs: { "selected-agency": _vm.id },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }